import { render, staticRenderFns } from "./AuditPage.vue?vue&type=template&id=c5ccb560"
import script from "./AuditPage.vue?vue&type=script&lang=ts"
export * from "./AuditPage.vue?vue&type=script&lang=ts"
import style0 from "./AuditPage.vue?vue&type=style&index=0&id=c5ccb560&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports